import VueRouter from 'vue-router';

// Vue Templates
import NewPage from '@/views/NewPage.vue';
import Home from '@/views/Home.vue';

const routes = [
    // {
    //     path: '/',
    //     name: 'Home',
    //     component: Home,
    // },
    {
        path: '/',
        name: 'NewPage',
        component: NewPage,
    },
];

const router = new VueRouter({
    base: '/',
    mode: 'history',
    routes,
});

export default router;
